import { h } from 'vue'
import { Minus, Plus } from '@jd/jdesign-icons-vue'

export function MinusSquare() {
  return h('div', { class: 'custom-square' }, h(Minus))
}

export function PlusSquare() {
  return h('div', { class: 'custom-square' }, h(Plus))
}
